<template>
	<div class="publicAuctions flex-fill">
		<ul v-show="auctions.length" ref="auctionsList" class="auctionsList h-100">
			<public-auction-list-item v-for="a in auctions" :auction="a" :key="a.id"></public-auction-list-item>
		</ul>
		<div v-if="!auctions.length"  class="d-flex flex-fill p-3">
			<div v-if="loading" class="m-auto" v-html="$t('base.loading')"></div>
			<div v-else class="text-primary m-auto">
				<div class="px-5 py-5">
					<img v-if="audience?.toUpperCase() === 'MTS'"
						src="/images/theme/mts/bear/challenges/bear-no-finished.png"
						:alt="$t('home.auth_auctions_no_data')" />
					<img v-else src="/images/theme/default/bear/challenges/bear-no-finished.png"
						:alt="$t('home.auth_auctions_no_data')" />
				</div>
				<p class="mb-5">{{ $t('login.auth_auctions_no_data') }}</p>
				<b-button type="button" variant="primary" size="lg" @click="onPublicAuctionClick(); btnSfx()"
					class="pl-5 pr-5">
					{{ $t('login.auth_auctions_no_data_btn_next') }}
				</b-button>
			</div>
		</div>
	</div>
</template>
<script>
import Vue from 'vue'
import api from '../../api'
import PublicAuctionListItem from './PublicAuctionListItem.vue'

const PublicAuctionList = Vue.component('public-auction-list', {
	components: {
		PublicAuctionListItem,
	},

	props: {
		audience: String,
	},

	data() {
		return {
			auctions: [],
			perPage: 25,
			loading: false,
			canLoadMore: true,
		}
	},

	methods: {
		btnSfx() {
			this.$store.dispatch('sound/sfx', 'Button')
		},

		loadData(nextPage = false) {
			let page = nextPage ? this.page + 1 : 1
			if (page == 1) this.auctions = []

			if (page > 1 && !this.canLoadMore) return

			if (this.loading) return
			this.loading = true

			api.publicAuctions({
				audience: this.audience,
				page: page,
				count: this.perPage,
			})
				.then((res) => {
					this.page = page
					if (res.data == undefined) res.data = []

					this.canLoadMore = res.data.length === this.perPage

					if (page == 1) this.auctions = res.data
					else this.auctions = this.auctions.concat(res.data)
				})
				.catch((e) => {
					console.error(`Error loading page ${page}`)
				})
				.then((r) => {
					this.loading = false
				})
		},

		onPublicAuctionClick() {
			this.$root.$emit('onPublicAuctionClick')
		},

		scrollHandler() {
			const listElm = this.$refs.auctionsList
			if (Math.ceil(listElm.scrollTop + listElm.clientHeight + this.page) >= listElm.scrollHeight) {
				this.loadData(true)
			}
		},
	},

	computed: {
		user() {
			return this.$store.state.auth.user
		},
	},

	watch: {
		open() {
			document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
			document.body.scrollTop = 0 // For Safari
			if (this.open) document.body.classList.add('lock')
			else document.body.classList.remove('lock')
		},
	},

	created() {
		this.loadData()
	},

	mounted() {
		if (this.$refs.auctionsList) this.$refs.auctionsList.addEventListener('scroll', this.scrollHandler)
	},

	beforeDestroy() {
		document.getElementById('loader').classList.remove('show')
		if (this.$refs.auctionsList) this.$refs.auctionsList.removeEventListener('scroll', this.scrollHandler)
	},
})

export default PublicAuctionList
</script>
